// userModel.js
import { collection, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase.js";

export const usersCollection = collection(db, "users");
export const contactPersonCollection = collection(db, "contactPersons");

export const userDoc = (id) => doc(db, "users", id);

// use this as a default data generator instead of a schema object
export const createUserData = (data) => ({
  uid: data.uid,
  searchKey: data.searchKey,
  name: data.name,
  role: data.role,
  emailId: data.emailId,
  phoneNumber: data.phoneNumber,
  createdTimestamp: serverTimestamp(),
  lastModifiedTimestamp: serverTimestamp(),
  status: data.status ?? true,
  createdBy: data.createdBy,
  modifiedBy: data.modifiedBy ?? null,
});
